/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { useParams } from 'react-router'

import { Growl } from 'primereact/growl'

import { messageConstants } from '../_constants'
import { getLoader } from '../_common/utils'
import { industryActions, lookupActions } from '../_actions'
import AddIndustryComponent from '../components/AddIndustryComponent'

function AddIndustryContainer({ addIndustry, sectorList, lookupSector,
  isLoading, getIndustryById, industryEntry, updateIndustry, addIndustryMessage, clearAllMessages, updateIndustryMessage }) {
  const { sectorId } = useParams()
  const history = useHistory()
  const growl = useRef()
  const { id } = useParams()
  useEffect(() => {
    if (id)
      getIndustryById(id)
  }, [getIndustryById, id])
  useEffect(() => {
    if (sectorList) { lookupSector() }
    if (addIndustryMessage === 'success') {
      growl.current.show({ severity: 'success', summary: '', detail: 'Industry Added Successfully' })
      if (sectorId)
        setTimeout(function () { history.push('/dashboard/sector-list'); clearAllMessages() }, 1000)
      else {
        setTimeout(function () { history.push('/dashboard/industry-list'); clearAllMessages() }, 1000)
      }
    }
    if (updateIndustryMessage === 'success') {
      growl.current.show({ severity: 'success', summary: '', detail: 'Industry Updated Successfully' })
      setTimeout(function () {
        history.push('/dashboard/industry-list'); clearAllMessages()
      }, 1000)

    }
    else if (addIndustryMessage === 'industryname-exist' || updateIndustryMessage === 'industryname-exist') {
      growl.current.show({ severity: messageConstants.sevirity.error, summary: '', detail: 'Industry Name already exists under this sector' })
      setTimeout(function () { clearAllMessages() }, 3000)
    }
  }, [addIndustryMessage, updateIndustryMessage, industryEntry, isLoading])
  return (
    <div className="p-grid pageWrapper">
      {isLoading ? getLoader() : ''}
      <Growl ref={growl} />
      <AddIndustryComponent
        addIndustry={addIndustry}
        sectorList={sectorList}
        getIndustryById={getIndustryById}
        industryEntry={industryEntry}
        updateIndustry={updateIndustry}
        sectorId={sectorId}
      />
    </div>
  )
}
const mapStateToProps = state => {
  return {
    sectorList: state.lookup.sector ? state.lookup.sector : [],
    industryEntry: state.industry.industryEntry ? state.industry.industryEntry : null,
    isLoading: state.industry.isLoading,
    addIndustryMessage: state.industry.addIndustryMessage,
    updateIndustryMessage: state.industry.updateIndustryMessage,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    addIndustry: (industry) => dispatch(industryActions.addIndustry(industry)),
    lookupSector: () => dispatch(lookupActions.lookupSector()),
    getIndustryById: (id) => dispatch(industryActions.getIndustryById(id)),
    updateIndustry: (industry, id) => dispatch(industryActions.updateIndustry(industry, id)),
    clearAllMessages: () => dispatch(industryActions.clearAllMessages())
  }
}

AddIndustryContainer.propTypes = {
  addIndustry: PropTypes.func,
  sectorList: PropTypes.array,
  lookupSector: PropTypes.func,
  isLookupLoadedAll: PropTypes.bool,
  getIndustryById: PropTypes.func,
  isLoading: PropTypes.bool,
  updateIndustry: PropTypes.func,
  addIndustryMessage: PropTypes.string,
  industryEntry: PropTypes.object,
  clearAllMessages: PropTypes.func,
  updateIndustryMessage: PropTypes.string
}

export default connect(mapStateToProps, mapDispatchToProps)(AddIndustryContainer)
